<!--
 * @Author: your name
 * @Date: 2021-06-26 11:50:40
 * @LastEditTime: 2021-06-26 13:38:34
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /visual-products-site-web/src/components/community/img_flex/mutong.vue
-->
<template>
  <div ref="barrel">
    <slot></slot>
  </div>
</template>

<script>
const dealWidth = (items, width, maxWidth) => {
  let remain = maxWidth - width;
  let num = items.length;
  let remains = remain % num;
  let residue = Math.floor(remain / num);
  items.forEach((item, index) => {
    if (index === num - 1) {
      item.style.width = item.realWidth + residue + remains + 'px';
    } else {
      item.style.width = item.realWidth + residue + 'px';
    }
  })
}
export default {
  name: 'VueBarrel',
  data () {
    return {
      barrelWidth: 0,
      brandBox: null,
      margin: 0,
      shouldUpdate: false,
    }
  },
  props: {
    ele: {
      type: String,
      default: 'vue-barrel'
    },
    list: {
      type: Array,
      default: () => { }
    }
  },
  created () {
    if (this.shouldUpdate) {
      this.barrelBox = this.$refs.barrel;
      this.barrelWidth = this.barrelBox.offsetWidth;
      this.setWidth();
    }
  },
  methods: {
    setWidth () {
      console.log(11);
      this.shouldUpdate = false;
      let ele = '.' + this.ele.replace('.', '');
      let items = this.barrelBox.querySelectorAll(ele);
      let widths = 0;
      let rowWidth = 0;
      let rowList = [];
      let marginLeft = 0;
      let marginRight = 0;
      let paddingLeft = 0;
      let paddingRight = 0;
      let barrelWidth = this.barrelWidth;


      Array.prototype.forEach.call(items, (item) => {
        paddingRight = 0;
        paddingLeft = 0;
        marginLeft = parseInt(window.getComputedStyle(item, "").getPropertyValue('margin-left'));
        marginRight = parseInt(window.getComputedStyle(item, "").getPropertyValue('margin-right'));
        let boxSizing = window.getComputedStyle(item, "").getPropertyValue('box-sizing');
        if (boxSizing !== 'border-box') {
          paddingRight = parseInt(window.getComputedStyle(item, "").getPropertyValue('padding-right'));
          paddingLeft = parseInt(window.getComputedStyle(item, "").getPropertyValue('padding-left'));
        }
        widths = item.offsetWidth + marginLeft + marginRight + 1;
        item.realWidth = item.offsetWidth - paddingLeft - paddingRight + 1;
        let tempWidth = rowWidth + widths;
        if (tempWidth > barrelWidth) {
          dealWidth(rowList, rowWidth, barrelWidth);
          rowList = [item];
          rowWidth = widths;
        } else {
          rowWidth = tempWidth;
          rowList.push(item);
        }
      })
    },
  },



  watch: {
    list (newer, older) {
      this.shouldUpdate = true;
    }
  },

}
</script>


// WEBPACK FOOTER //
// src/components/community/img_flex/VueBarrel.vue